import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { inject, nextTick, reactive, ref, watch } from 'vue';
import { getBetterUrl } from '@/utils/uri-utils';
import { canUseDOM } from '@/utils/dom-utils';
import { debounce } from 'lodash-es';
import type { SiteRichTextProps, SiteRichTextRef } from '../types/elements/site-rich-text';
import useDevice from '@/hooks/useDevice';
import gsap from 'gsap';
import utils from '@/utils';
import EventBus from '@/utils/bus';
import BUS_EVENTS from '@/utils/bus-events';


export default /*@__PURE__*/_defineComponent({
  __name: 'SiteRichText',
  props: {
    field: {},
    editable: { type: Boolean },
    hasLinkAnimation: { type: Boolean, default: true },
    tag: { default: 'div' }
  },
  setup(__props: any) {

const props = __props;
const $bus = inject<EventBus>('$bus')!;
const { isMobileOrTablet } = useDevice();
const state = reactive({
  richField: props.field,
  eventBound: false,
});
const rootEl = ref<SiteRichTextRef>();

const getTooltipMsg = (e: MouseEvent) => {
  const $el = e.target as HTMLElement;
  const $tip = $el.closest('span[data-tooltip]') as HTMLElement | undefined;
  return $tip?.dataset.tooltip;
};
const onMouseEnter = debounce((e: MouseEvent) => {
  if (isMobileOrTablet.value) return;
  const el = e.target as HTMLElement;
  const target = el.querySelector('em') as HTMLElement | undefined;
  $bus.emit(BUS_EVENTS.TOOLTIP_SHOW, {
    text: getTooltipMsg(e),
    target: target,
  });
}, 100);
const onMouseLeave = debounce((e: MouseEvent) => {
  if (isMobileOrTablet.value) return;
  $bus.emit(BUS_EVENTS.TOOLTIP_HIDE);
}, 100);
const onClick = debounce((e: MouseEvent) => {
  if (isMobileOrTablet.value) {
    $bus.emit(BUS_EVENTS.TOOLTIP_SHOW, {
      text: getTooltipMsg(e),
      target: e.target,
    });
  }
}, 200);
const update = debounce(async () => {
  const $container = rootEl.value?.$el;
  if (!canUseDOM() || !props.field || props.editable) {
    state.richField = props.field;
    return;
  }
  if (state.eventBound && $container && typeof $container.querySelectorAll === 'function') {
    const $tooltips = $container.querySelectorAll('span[data-tooltip]') as NodeListOf<HTMLElement>;
    console.log($tooltips);
    $tooltips.forEach((tp) => {
      tp.removeEventListener('mouseenter', onMouseEnter);
      tp.removeEventListener('mouseleave', onMouseLeave);
    });
    state.eventBound = false;
  }
  const { value, ...rest } = props.field;
  const div = document.createElement('DIV');
  div.innerHTML = value ?? '';
  const links = div.getElementsByTagName('A') as HTMLCollectionOf<HTMLAnchorElement>;
  for (const link of links) {
    link.href = getBetterUrl(link.href);
  }
  state.richField = {
    value: div.innerHTML,
    ...rest,
  };
  div.remove();
  await nextTick();
  if ($container && typeof $container.querySelectorAll === 'function') {
    const $tooltips = $container.querySelectorAll('span[data-tooltip]') as NodeListOf<HTMLElement>;
    $tooltips.forEach((tp) => {
      tp.addEventListener('mouseenter', onMouseEnter);
      tp.addEventListener('mouseleave', onMouseLeave);
    });
    state.eventBound = true;
  }
}, 100);
watch(() => props.field?.value, update, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (state.richField)
    ? (_openBlock(), _createBlock(_unref(RichText), {
        key: 0,
        tag: __props.tag,
        editable: __props.editable,
        field: state.richField,
        class: _normalizeClass(["e-rich-text", [{ 'has-link-animation': __props.hasLinkAnimation }]]),
        onClick: _unref(onClick),
        ref_key: "rootEl",
        ref: rootEl
      }, null, 8, ["tag", "editable", "field", "class", "onClick"]))
    : _createCommentVNode("", true)
}
}

})